import { AiFeature } from '../../../../../models/AiFeature'
import { HeaderResultOption } from '../MeetingResults/ResultCard/Header/HeaderResultOptions/HeaderResultOptionsButton'
import { useCallback } from 'react'
import { useZocksAuth } from '../../../../../components/ScopedBlock/hooks'
import { useExecuteForm } from './hooks'
import { TrackEvent, useTracking } from '../../common/tracking'
import { getRoomAndAIFeatureTrackingDetails } from '../../tracking'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import { useAppSelector } from '../../../../../store/hooks'

export const useFormRerunHeaderResultOption = (aiFeature: AiFeature): HeaderResultOption => {
  const { hasScope } = useZocksAuth()
  const { tracked } = useTracking()

  const roomSession = useAppSelector(selectRoomSession)

  const hasAiFeatureExecuteScope = hasScope('**', 'aifeature:execute', ['aifeature:admin'])

  const executeForm = useExecuteForm()

  const _handleRerunForm = useCallback(async () => {
    if (hasAiFeatureExecuteScope) {
      await executeForm(aiFeature.id)
    }
  }, [hasAiFeatureExecuteScope, executeForm, aiFeature.id])

  const handleRerunForm = tracked(_handleRerunForm, {
    eventName: TrackEvent.FORM_RERUN,
    eventDetails: {
      ...getRoomAndAIFeatureTrackingDetails(roomSession, aiFeature),
    },
  })

  return {
    selectOption: {
      id: 'rerun',
      label: 'Rerun',
      disabled: !hasAiFeatureExecuteScope,
    },
    icon: 'bi-arrow-counterclockwise',
    handleSelected: handleRerunForm,
  }
}
